import React, { useContext } from "react";
import { IconClose } from "../icons";
import { AppDialogContext } from "./AppDialog";

function AppDialogHeader({ title = null, subtitle = null, visual = null, action = null, className = "", children, ...rest }) {
  const { titleId, showCloseButton, onClose } = useContext(AppDialogContext);

  if (!children && !title && !subtitle && !visual && !action && !showCloseButton) {
    return null;
  }

  const subtitleClasses = [
    "ds-dialog__subtitle",
    visual ? "ds-dialog__subtitle--indented" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const classes = ["ds-dialog__header", className].filter(Boolean).join(" ");

  const controls = action || showCloseButton ? (
    <div className="ds-dialog__controls">
      {action}
      {showCloseButton ? (
        <button
          type="button"
          className="ds-dialog__close"
          aria-label="Dialog schliessen"
          onClick={onClose}
        >
          <IconClose sx={{ fontSize: 18 }} />
        </button>
      ) : null}
    </div>
  ) : null;

  if (children) {
    return (
      <header className={classes} {...rest}>
        {children}
      </header>
    );
  }

  return (
    <header className={classes} {...rest}>
      <div className="ds-dialog__heading">
        {(visual || title) && (
          <div className="ds-dialog__title-row">
            {visual ? (
              <div className="ds-dialog__header-visual" aria-hidden="true">
                {visual}
              </div>
            ) : null}
            {title ? (
              <h3 id={titleId} className="ds-dialog__title">
                {title}
              </h3>
            ) : null}
          </div>
        )}
        {subtitle ? <p className={subtitleClasses}>{subtitle}</p> : null}
      </div>
      {controls}
    </header>
  );
}

AppDialogHeader.appDialogZone = "header";

export default AppDialogHeader;
